import React from 'react';
import { useMissionStore } from '../stores/missionStore';
import { ScoreTypeSelector } from './ScoreTypeSelector';
import { FactionSelector } from './FactionSelector';
import { MissionDisplay } from './MissionDisplay';

export const MissionGenerator: React.FC = (): JSX.Element => {
  const { generatedMission, isGenerating, generateMission, saveMission } = useMissionStore();

  const containerStyle: React.CSSProperties = {
    maxWidth: '800px',
    margin: '0 auto',
  };

  const headerStyle: React.CSSProperties = {
    fontSize: '2rem',
    fontWeight: 700,
    color: '#d4af37',
    marginBottom: '32px',
    fontFamily: 'Cinzel, serif',
  };

  const formCardStyle: React.CSSProperties = {
    backgroundColor: '#16162a',
    borderRadius: '12px',
    padding: '32px',
    border: '1px solid rgba(212, 175, 55, 0.2)',
    marginBottom: '32px',
  };

  const buttonStyle: React.CSSProperties = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '14px 32px',
    backgroundColor: '#d4af37',
    color: '#0f0f1e',
    border: 'none',
    borderRadius: '8px',
    fontSize: '16px',
    fontWeight: 600,
    cursor: isGenerating ? 'not-allowed' : 'pointer',
    opacity: isGenerating ? 0.7 : 1,
    transition: 'all 0.2s ease',
    boxShadow: '0 4px 12px rgba(212, 175, 55, 0.3)',
  };

  return (
    <div style={containerStyle}>
      <h1 style={headerStyle}>Mission Generator</h1>

      <div style={formCardStyle}>
        <ScoreTypeSelector />
        <FactionSelector />

        <button
          onClick={generateMission}
          disabled={isGenerating}
          style={buttonStyle}
          onMouseEnter={e => {
            if (!isGenerating) {
              e.currentTarget.style.backgroundColor = '#e5c158';
              e.currentTarget.style.transform = 'translateY(-2px)';
              e.currentTarget.style.boxShadow = '0 6px 20px rgba(212, 175, 55, 0.4)';
            }
          }}
          onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = '#d4af37';
            e.currentTarget.style.transform = 'translateY(0)';
            e.currentTarget.style.boxShadow = '0 4px 12px rgba(212, 175, 55, 0.3)';
          }}
        >
          {isGenerating ? (
            <>
              <svg
                style={{
                  animation: 'spin 1s linear infinite',
                  marginRight: '8px',
                  width: '20px',
                  height: '20px',
                }}
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
              >
                <circle
                  style={{ opacity: 0.25 }}
                  cx="12"
                  cy="12"
                  r="10"
                  stroke="currentColor"
                  strokeWidth="4"
                ></circle>
                <path
                  style={{ opacity: 0.75 }}
                  fill="currentColor"
                  d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                ></path>
              </svg>
              Generating...
            </>
          ) : (
            'Generate Mission'
          )}
        </button>
      </div>

      {generatedMission && <MissionDisplay mission={generatedMission} onSave={saveMission} />}
    </div>
  );
};

export default MissionGenerator;
